'use strict';

import Swiper from 'swiper';

const SELECTOR = '.js-scroller';

function initialiseElement(element) {
    const scrollerElement = element.querySelector('.swiper-container');
    const scrollerType = element.dataset.scrollerType || null;
    const scrollerTitleSelector = '.season-scroller__title';
    const scrollerActiveItemSelector = '.swiper-slide-active';

    const prevButton = element.querySelector(
        element.dataset.scrollerPrevButtonSelector || '.button-previous'
    );

    const nextButton = element.querySelector(
        element.dataset.scrollerNextButtonSelector || '.button-next'
    );

    const mq = window.matchMedia('(max-width: 999px)');

    let scroller;

    const settings = {
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        direction: 'horizontal',
        speed: 300,
        loop: false,
        watchOverflow: true,
        simulateTouch: false,
        preventInteractionOnTransition: true,
        autoplay: false,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            1280: {
                slidesPerGroup: 2,
            }
        },
    };

    if (!mq.matches) {
        scroller = new Swiper( scrollerElement, settings );
    }

    function loadScroller(event) {
        if (event.matches) {
            scroller.destroy( true, true );
            updateNativePastEventsTitle();
        } else {
            scroller = new Swiper( scrollerElement, settings );
        }
    }

    mq.addListener(loadScroller);

    let scrollerTitle;

    if (scrollerType && !mq.matches) {
        scrollerTitle = element.querySelector(scrollerTitleSelector).innerHTML;
        scroller.on('slideChangeTransitionStart', updateScrollerPastEventsTitle);
    }

    function updateScrollerPastEventsTitle() {
        const titleElement = element.querySelector(scrollerTitleSelector);
        const activeSlide = element.querySelector(scrollerActiveItemSelector);
        const pastTitle = 'Previously';

        if(activeSlide.classList.contains('season-scroller-item--past')) {
            titleElement.innerHTML = pastTitle;
        } else {
            titleElement.innerHTML = scrollerTitle;
        }
    }

    function updateNativePastEventsTitle() {
        // Add some logic so that the scroller title is updated to "Previous" on mobile, the same way as desktop
        // Possibly using IntersectionObserver?
    }
}

(function () {
    document.querySelectorAll(SELECTOR).forEach(initialiseElement);
}());

export {
    initialiseElement
};
